import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { resetBlock } from '../../ServiceAppointmentBlockSlice';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../../../Config';


const RouterConnectionPage = (props) => {

const handleOnContinue = ()=>{
  EpiContext.navigateTo(Config.lobbyUrl);
};

  return (
      <div className='router-connection-page page-wrapper'>
        <div className='content'>
          <div className='title-page'>איך להתחבר לנתב של {window.Config.brand_Name_HE} ?</div>
          <div className='wrapper-sections'>
              <div className='section' style={{direction:'rtl'}}>
              בשביל להתחבר לנתב ,<br/>יש להיכנס לכתובת ה -IP :
                <div className='value'>{props.addressIP}</div>
              </div>
              <div className='section'>
                  <div>
                  פרטי התחברות בברירת המחדל הם:
                  </div>
                  <div>שם משתמש: <span>{props.user}</span> </div>
                  <div>סיסמה: <span>{props.password}</span> </div>
              </div>
              <div className='section'>אם שינית את אחד מהפרטים,<br/> יש להיכנס עם הפרטים העדכניים.</div>
          </div>
        </div>
        <div className='button-wrapper'>
            <BtnSubmit
                isBusiness={false}
                text='לאיזור האישי'
                onclick={handleOnContinue}
                formid='error-page'
                isDisplayArrows={false}
            />
        </div>
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
    addressIP: state.serviceAppointmentSchedulerBlock.dataEpi.addressIP,
    user: state.serviceAppointmentSchedulerBlock.dataEpi.user,
    password: state.serviceAppointmentSchedulerBlock.dataEpi.password,
  };
};

const mapDispatchToProps = { resetBlock };

export default connect(mapStateToProps, mapDispatchToProps)(RouterConnectionPage);
